import { ListParams } from '../../Components/List/hooks'
import { Filter } from '../../Components/Filters/types'

export type URL_STATE = {
  readonly websites: ReadonlyArray<string>
} & ListParams

export const INIT_URL_STATE: URL_STATE = {
  page: 1,
  tab: null,
  searchTerm: '',
  sort: null,
  websites: [],
}
export const URL_FILTERS: ReadonlyArray<Filter<URL_STATE>> = [
  {
    displayName: 'Sort By',
    fieldName: 'sort',
    type: 'radio',
    options: [
      { name: 'URL, A-Z', value: { sortBy: 'name', order: 'ASC' } },
      { name: 'URL, Z-A', value: { sortBy: 'name', order: 'DESC' } },
    ],
  },
  {
    displayName: 'Websites',
    fieldName: 'websites',
    type: 'checkbox',
    options: [
      { name: 'Brighteon', value: 'brighteon' },
      { name: 'Counterthink', value: 'counterthink' },
      { name: 'Natural news', value: 'natnews' },
      { name: 'Natural news radio', value: 'natnewsradio' },
      { name: 'News target', value: 'newstarget' },
    ],
  },
]
